import { DateTime } from "luxon";
import platform from "platform";
import { jwtDecode } from "jwt-decode";
import { monthNames } from "../store/GlobalVarriables";

const numberValidation = /^[1-9]\d*(\.\d+)?$|^0(\.\d+)?$/;
const emailValidation = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const osPlatform = platform.os.family || "Unknown";

export const isMobile = osPlatform === "Android" || osPlatform === "iOS";
export const isIOS = osPlatform === "iOS";
export const isAndroid = osPlatform === "Android";

export const isOnlyNumbers = (value) => numberValidation.test(value);
export const isValidEmail = (email) => emailValidation.test(email);
export const isWholeNumber = (str) => /^-?\d+$/.test(str);
export const isDecimalNumber = (str) => /^-?\d+(\.\d*)?$/.test(str);

export const capitalize = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const formatDate = (date, t) => {
  const dateToFormatt = new Date(date);
  const day = dateToFormatt.getDate();
  const month = monthNames[dateToFormatt.getMonth()];

  const year = dateToFormatt.getFullYear();

  const formattedDate = `${day} ${t(month.toLowerCase())} ${year}`;

  return formattedDate;
};

export const formatDuration = (duration) => {
  const hours = Math.floor(duration / 60);
  const minutes = duration - hours * 60;

  return minutes > 0
    ? `${hours} h ${minutes} min session`
    : `${hours} h session`;
};

export const combineToUTC = (dateStr, timeStr, localZone) => {
  // Create a DateTime from the local date and time
  const localDateTime = DateTime.fromISO(`${dateStr}T${timeStr}`, {
    zone: localZone,
  });

  // Convert to UTC
  const utcDateTime = localDateTime.toUTC();

  return utcDateTime.toISO(); // Returns ISO string in UTC
};

export const getQueryParam = (key, location) => {
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get(key);
};

export const getDecodedToken = () => {
  const token = localStorage.getItem("ps10005000");
  return token ? jwtDecode(token) : null;
};

export const removeEmptyKeys = (obj) => {
  for (let key in obj) {
    const value = obj[key];

    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      removeEmptyKeys(value);

      if (Object.keys(value).length === 0) {
        delete obj[key];
      }
    } else if (value === undefined || value === null) {
      delete obj[key];
    }
  }

  return Object.keys(obj).length === 0 ? null : obj;
};

export const getChangedValues = (finalData, initialValues) => {
  const changedValues = {};
  Object.keys(finalData).forEach((key) => {
    if (finalData[key] !== initialValues[key]) {
      changedValues[key] = finalData[key];
    }
  });

  return changedValues;
};

export const normalizeString = (str) => {
  if (str) return str.trim().toLowerCase().replace(/\s+/g, "_");
};
